import styled, { css } from 'styled-components';
import { Container } from 'app/client/styled';
import { xl } from '@exonet/react-shared/lib/styled';
import { Spinner } from '@exonet/react-shared/lib/Elements/Loader/styled';

export const Tile = styled(Container)`
  display: flex;
  flex-direction: column;
  min-height: fit-content;

  ${xl(css`
    padding: var(--lg-padding);
  `)};
`;

export const Header = styled.div`
  display: flex;
  flex-flow: row;
  justify-content: space-between;
  height: 40px;
`;

export const Title = styled.h3`
  font-weight: 600;
  margin: 0;
  color: var(--text);

  > svg {
    margin-right: var(--xs-padding-horizontal);
    color: var(--title-text);
  }
`;

export const Actions = styled.div`
  display: flex;
  align-items: flex-start;
  height: 40px;

  > button {
    height: 70%;
    background-color: var(--tile-button-bg);
    color: var(--title-text);
    box-shadow: none;

    > span {
      font-size: var(--xs-font-size);
    }

    :hover {
      background-color: var(--tile-button-bg-hover);
    }
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 100px;

  .shared-table {
    box-shadow: none;
    width: 100%;

    .header {
      background-color: var(--form-bg);
    }

    .table-header {
      :first-child {
        padding-left: 0;
      }

      :last-child {
        padding-right: 0;
      }

      :after {
        display: none;
      }
    }

    .item {
      background-color: transparent !important;

      :not(:last-child) {
        border-bottom: 1px solid var(--bg-3);
      }

      .column {
        :first-child {
          padding-left: 0;
        }

        :last-child {
          padding-right: 0;
        }

        :after {
          display: none;
        }
      }
    }
  }

  .data-manager-content {
    min-height: fit-content;
    padding: 0 !important;
    box-shadow: none;
    animation: none;
  }

  ${Spinner} {
    border-width: 1px !important;
    width: 16px !important;
    height: 16px !important;
  }
`;
